import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import FileUploaderSelect from "./FileUploaderSelect";
import AVRepair from "./AVRepair";

const AVRepairComponent = (props) => {
    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleDownload,
        titleChoose,
        titleLoadMore,
        titleSelect,
        titleDelete,
        titleRepairAnotherVideo,
        titleReady,
        titleCurrentFile,
    } = props.attributes;

    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [showComponent, setShowComponent] = useState("");

    const handleDataChange = (url, duration, newFileId, newFileName) => {
        setFileId(newFileId);
        setFileName(newFileName);
        setShowComponent(true);
    };

    const [showUploader, setShowUploader] = useState(true);

    const handleDisplayUploader = (value) => {
        setShowUploader(value);
    };

    return (
        <div>
            {showComponent && (
                <>
                    <AVRepair
                        setShowUploader={setShowUploader}
                        fileId={fileId}
                        fileName={fileName}
                        attributes={props.attributes}
                    />
                </>
            )}

            <div style={{ marginTop: "20px" }}>
                <FileUploaderSelect
                    attributes={props.attributes}
                    componentRequestData={"AVRepairData"}
                    /* componentUrlUploader={'UrlUploader'} */
                    setShowComponent={setShowComponent}
                    showUploader={showUploader}
                    onDataChange={handleDataChange}
                />
            </div>
        </div>
    );
};

export default AVRepairComponent;

if (document.getElementById("av-repair")) {
    const avRepairElement = document.getElementById("av-repair");
    const root = createRoot(avRepairElement);
    const attributes = { ...avRepairElement.dataset };
    root.render(<AVRepairComponent attributes={attributes} />);
}
